import { render, staticRenderFns } from "./FormControlArray.vue?vue&type=template&id=5098b6a8&scoped=true"
import script from "./FormControlArray.vue?vue&type=script&lang=js"
export * from "./FormControlArray.vue?vue&type=script&lang=js"
import style0 from "./FormControlArray.vue?vue&type=style&index=0&id=5098b6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5098b6a8",
  null
  
)

export default component.exports